import {Component, DestroyRef, OnInit, ViewChild} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {TranslocoModule, TranslocoService} from '@jsverse/transloco';

import {BoiteDialogueGeneriqueComponent, DonneesColonne, SimpleLibelleComponent, SimplePanelComponent, GrilleComponent, DonneesGrilleSelection} from "../../../../../val-ammon-composants/val-composants-lib/src/public-api";
import {AeFComplementComptableBt30} from '../../../../../val-ammon-services/val-services-efact-lib/src/public-api';

//Clés de traduction des libellés des colonnes, par champ
//  SIRET, SIREN, IBAN et BIC sont des sigles identiques dans toutes les langues : ils restent en dur.
const clesColonnes: Record<string, string> =
{
  nomEntreprise: "complement-comptable.selection-dialogue.colonnes.nom-entreprise",
  dateMiseAJourIban: "complement-comptable.selection-dialogue.colonnes.date-mise-a-jour-iban",
  numeroTva: "complement-comptable.selection-dialogue.colonnes.numero-tva"
};

//Boîte de dialogue de sélection d’un complément comptable
@Component (
{
  selector: 'val-selection-complement-comptable-dialogue',
  imports:
  [
    BoiteDialogueGeneriqueComponent,
    SimpleLibelleComponent,
    SimplePanelComponent,
    GrilleComponent,
    TranslocoModule
  ],
  templateUrl: './selection-complement-comptable-dialogue.component.html',
  styleUrl: './selection-complement-comptable-dialogue.component.scss',
})
export class SelectionComplementComptableDialogueComponent implements OnInit
{
  //Création
  //  Paramètres
  //    translocoService : Service de traduction
  //    destroyRef       : Référence de destruction du composant
  constructor (private translocoService: TranslocoService, private destroyRef: DestroyRef)
  {
    this.colonnes = [];
    this.donnees = new DonneesSelectionComplementComptable ();
  }

  //Boîte de dialogue
  @ViewChild ("boiteDialogue")
  public boiteDialogue!: BoiteDialogueGeneriqueComponent<DonneesSelectionComplementComptable>;

  //Grille
  @ViewChild ("grille")
  public grille!: GrilleComponent;

  //Colonnes
  public colonnes: DonneesColonne[];

  //Données de la boite de dialogue
  public donnees: DonneesSelectionComplementComptable;

  //Initialise le composant
  public ngOnInit () : void 
  {
    this.colonnes =
    [
      {identifiant: "1", champ: "nomEntreprise", libelle: "", format: "TXT", taille: 250, visible: true},
      {identifiant: "2", champ: "siretEntreprise", libelle: "SIRET", format: "TXT", taille: 110, visible: true},
      {identifiant: "3", champ: "sirenEntreprise", libelle: "SIREN", format: "TXT", taille: 80, visible: true},
      {identifiant: "4", champ: "iban", libelle: "IBAN", format: "TXT", taille: 200, visible: true},
      {identifiant: "5", champ: "bic", libelle: "BIC", format: "TXT", taille: 80, visible: true},
      {identifiant: "6", champ: "dateMiseAJourIban", libelle: "", format: "DAT", taille: 165, visible: true},
      {identifiant: "7", champ: "numeroTva", libelle: "", format: "TXT", taille: 115, visible: true}
    ];

    //Les libellés des colonnes suivent la langue active ; ils sont mis à jour en place pour que
    //la grille conserve tailles et ordre choisis par l’utilisateur
    this.translocoService.selectTranslation ()
      .pipe (takeUntilDestroyed (this.destroyRef))
      .subscribe (() => this.TraduireColonnes ());
  }

  //Traduit les libellés des colonnes dans la langue active
  private TraduireColonnes () : void
  {
    for (const colonne of this.colonnes)
    {
      if (clesColonnes[colonne.champ])
        colonne.libelle = this.translocoService.translate (clesColonnes[colonne.champ]);
    }
  }

  //Ouvre la boite de dialogue
  //  Retourne
  //    Données de sélection d’un complément comptable
  public async Ouvrir () : Promise<DonneesSelectionComplementComptable> 
  {
    let operation: Promise<DonneesSelectionComplementComptable>;

    this.donnees.valide = false;
    this.grille.Reinitialiser ();

    operation = this.boiteDialogue.Ouvrir ();

    return operation;
  }

  //Valide la sélection
  public Valider () : void 
  {
    this.donnees.valide = true;

    this.boiteDialogue.fonctionRetour (this.donnees);
    this.boiteDialogue.Fermer ();
  }

  //Annule la sélection
  public Annuler () : void 
  {
    this.donnees.valide = false;

    this.boiteDialogue.fonctionRetour (this.donnees);
    this.boiteDialogue.Fermer ();
  }
  
  //Exécute les actions sur le changement de sélection
  //  Paramètres
  //    donneesGrilleSelection : Données de sélection de la grille
  public ExecuterActionSurChangementSelection (donneesGrilleSelection: DonneesGrilleSelection) : void 
  {
    this.boiteDialogue.validerDesactive = donneesGrilleSelection.identifiantsSelectionnes.length === 0;

    if (donneesGrilleSelection.identifiantsSelectionnes.length > 0)
      this.donnees.identifiant = donneesGrilleSelection.identifiantsSelectionnes[0];
  }
}

//Représente les données de sélection d’un complément comptable
export class DonneesSelectionComplementComptable 
{
  //Création
  constructor () 
  {
    this.numeroFacture = "";
    this.complementsComptable = [];
    this.valide = false;
    this.identifiant = "";
  }

  //Numéro de la facture
  public numeroFacture: string;

  //Compléments comptable
  public complementsComptable: AeFComplementComptableBt30[];

  //Indique si validé
  public valide: boolean;

  //Identifiant du complément comptable
  public identifiant: string;
}
